import React from 'react'
import PropTypes from 'prop-types'

import styles from './ConfirmationModal.module.css'

import Modal, { ModalBody, ModalHeader } from '../Modal'
import Button from '../Button'
import Heading from '../Heading'

const ConfirmationModal = (props) => {
  const {
    isOpen,
    title,
    description = '',
    children,
    onCloseButtonClick,
    onConfirmButtonClick,
    confirmButtonText,
    cancelButtonText,
    disableConfirmButton,
    style = {}
  } = props

  return (
    <Modal
      isOpen={isOpen}
      contentLabel='Confirmation Modal'
      ariaHideApp={false}
      onRequestClose={onCloseButtonClick}
      style={style}
      shouldCloseOnOverlayClick={false}
    >
      <ModalHeader onClose={onCloseButtonClick}>
        <Heading level={2}>{title}</Heading>
      </ModalHeader>
      <ModalBody>
        <div className='modal-body'>{children || description}</div>
        <div className={styles.ModalFooter}>
          <Button variant='danger' size='sm' disabled={disableConfirmButton} onClick={onConfirmButtonClick}>
            {confirmButtonText}
          </Button>
          <Button className={styles.ModalCancelButton} variant='link-default' size='sm' onClick={onCloseButtonClick}>
            {cancelButtonText}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

ConfirmationModal.propTypes = {
  /**
   * modal Open
   */
  isOpen: PropTypes.bool,
  /**
   * Modal title
   */
  title: PropTypes.string,
  /**
   * Modal description/Body
   */
  description: PropTypes.string,
  /**
   * Function to execute on close button click
   */
  onCloseButtonClick: PropTypes.func,
  /**
   * Function to execute on confirm button click
   */
  onConfirmButtonClick: PropTypes.func,
  /**
   * Confirm button text
   */
  confirmButtonText: PropTypes.string,
  /**
   * Cancel button text
   */
  cancelButtonText: PropTypes.string,
  /**
   * Disable confirm button
   */
  disableConfirmButton: PropTypes.bool
}

export default ConfirmationModal
